import React from 'react';
import { ArrowLeft, AlertTriangle, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import NearbyAreas from './NearbyAreas';
import AreaDedicatedArticle from '../AreaDedicatedArticle';
import AreaRelatedArticles from '../AreaRelatedArticles';

const HighwayTemplate = ({ areaData, displayName, phone, brand, images }) => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
      {/* Emergency Header */}
      <header id="header" className="area-hero-header" style={{
        background: 'linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)',
        color: 'white',
        borderRadius: '1.5rem',
        padding: '3rem 2rem',
        marginBottom: '2rem',
        textAlign: 'center',
        position: 'relative',
        boxShadow: '0 10px 30px rgba(211, 47, 47, 0.4)',
        marginTop: '2rem'
      }}>
        <nav aria-label="الرجوع إلى قائمة المناطق">
          <Link to="/areas" style={{
            position: 'absolute', top: '1rem', left: '1rem', color: 'white',
            textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem',
            fontSize: '1rem', fontWeight: 600
          }}>
            <ArrowLeft size={20} /> المناطق
          </Link>
        </nav>
        <nav aria-label="مسار التنقل" style={{ fontSize: '0.95rem', marginBottom: '1rem', opacity: 0.95, direction: 'rtl', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
          <Link to="/" style={{ color: '#ffc107', textDecoration: 'none', fontWeight: 700 }}>الرئيسية</Link>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}>/</span>
          <Link to="/areas" style={{ color: '#ffc107', textDecoration: 'none', fontWeight: 700 }}>مناطق الخدمة</Link>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}>/</span>
          <span style={{ color: '#ffffff', fontWeight: 800 }}>ونش انقاذ {displayName}</span>
        </nav>
        <h1 style={{ fontSize: '3rem', fontWeight: 900, marginBottom: '1rem', direction: 'rtl' }}>
          ونش انقاذ {displayName} | خصم 50%
        </h1>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
          background: '#ffc107', color: '#b71c1c', padding: '0.8rem 1.5rem',
          borderRadius: '2rem', fontSize: '1.3rem', fontWeight: 900,
          marginBottom: '1rem', direction: 'rtl', boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
        }}>
          <AlertTriangle size={24} />
          <span>استجابة فورية خلال {areaData.responseTime}</span>
        </div>
        <p style={{ fontSize: '1.3rem', fontWeight: 600, maxWidth: '800px', margin: '0 auto', direction: 'rtl' }}>
          {areaData.intro}
        </p>
      </header>

      {/* Safety Alert */}
      <aside aria-label="تعليمات وإجراءات الأمان على الطريق السريع" style={{ background: '#fff3cd', borderLeft: '5px solid #ffc107', padding: '1.5rem', borderRadius: '0.5rem', marginBottom: '2rem', direction: 'rtl', color: '#856404' }}>
        <h3 style={{ margin: '0 0 0.5rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <ShieldCheck size={24} /> تعليمات هامة للأمان على الطريق:
        </h3>
        <ul style={{ margin: 0, paddingRight: '1.5rem', lineHeight: 1.8 }}>
          <li>أوقف سيارتك في أقصى اليمين بعيداً عن مسار السيارات.</li>
          <li>قم بتشغيل أضواء الانتظار (الفلاشر) فوراً.</li>
          <li>لا تحاول عبور الطريق السريع، ابق داخل السيارة أو خلف الحواجز الآمنة.</li>
          <li>اتصل فوراً برقم الطوارئ <strong>{phone}</strong> لتوجيه أقرب ونش إليك.</li>
        </ul>
      </aside>

      {/* Highway specific coverage */}
      <section id="local-coverage" aria-labelledby="coverage-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '2px solid #ffc107', direction: 'rtl' }}>
        <h2 id="coverage-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#b71c1c', marginBottom: '1.5rem', textAlign: 'center' }}>
          نقاط التمركز السريعة على طول {displayName}
        </h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '1rem', lineHeight: 1.8 }}>
          أوناشنا موزعة استراتيجياً لخدمة النقاط التالية لتجنب زحام وتكدس الطرق:
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          {areaData.landmarks.map((lm, i) => (
            <span key={i} style={{ background: '#f8f9fa', padding: '0.5rem 1rem', borderRadius: '2rem', border: '1px solid #ddd', fontWeight: 600 }}>📍 {lm}</span>
          ))}
          {areaData.streets.map((st, i) => (
            <span key={i} style={{ background: '#f8f9fa', padding: '0.5rem 1rem', borderRadius: '2rem', border: '1px solid #ddd', fontWeight: 600 }}>🛣️ {st}</span>
          ))}
        </div>
      </section>

      {/* Dedicated Supporting Article Section */}
      <AreaDedicatedArticle
        areaData={areaData}
        displayName={displayName}
        templateType="Highway"
        phone={phone}
      />

      {/* Related Supporting Articles & Pillar Guides */}
      <AreaRelatedArticles areaName={displayName} />

      {/* FAQ */}
      {areaData.faqs && areaData.faqs.length > 0 && (
        <section id="faq" aria-labelledby="faq-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '1px solid #ddd', direction: 'rtl' }}>
          <h2 id="faq-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#b71c1c', marginBottom: '1.5rem', textAlign: 'center' }}>أسئلة شائعة عن الإنقاذ في {displayName}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {areaData.faqs.map((faq, index) => (
              <article key={index} style={{ background: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '1rem', padding: '1.5rem' }}>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#d32f2f', marginBottom: '0.5rem' }}>{faq.q}</h3>
                <p style={{ margin: 0, color: '#333', lineHeight: 1.6 }}>{faq.a}</p>
              </article>
            ))}
          </div>
        </section>
      )}

      {/* Nearby Areas — Internal Linking */}
      <NearbyAreas nearby={areaData.nearby} accentColor="#d32f2f" />
    </div>
  );
};
export default HighwayTemplate;
